<template>

<div class="template-preview-thumbnail" :style="bodyBackground">
    <div class="thumbnail-page-menu" :style="pageMenuBackground"></div>
    <div class="thumbnail-header" :style="headerBackground">
        <div class="thumbnail-logo-shape" :style="headerColor"></div>
    </div>
    <div class="thumbnail-product-menu" :style="productMenuBackground"></div>
    <div class="thumbnail-main-body">
        <div class="thumbnail-marquee"></div>
        <div class="thumbnail-departments"></div>
        <div class="thumbnail-departments"></div>
        <div class="thumbnail-departments"></div>
        <div class="thumbnail-section-header"></div>
        <div class="thumbnail-product-grid">
            <div class="thumbnail-button1" :style="buttonColorOne"></div>
            <div class="thumbnail-button2" :style="buttonColorTwo"></div>
        </div>
        <div class="thumbnail-product-grid">
            <div class="thumbnail-button1" :style="buttonColorOne"></div>
            <div class="thumbnail-button2" :style="buttonColorTwo"></div>
        </div>
        <div class="thumbnail-product-grid">
            <div class="thumbnail-button1" :style="buttonColorOne"></div>
            <div class="thumbnail-button2" :style="buttonColorTwo"></div>
        </div>
    </div>
    <div class="thumbnail-footer" :style="footerBackground"></div>
</div>     

</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: [ 'templateData' ],
    computed: {
		...mapGetters('website_module', [
            'getStyleOptions'
        ]),
        bodyBackground() {
			let backgroundColor = 'rgb('
			backgroundColor += (this.templateData.siteOptions.backgroundColor.value !== '' && this.templateData.siteOptions.backgroundColor.value !== null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.backgroundColor.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.backgroundColor.defaultColor]
			backgroundColor += ')'
			return {
				backgroundColor: backgroundColor,
				backgroundImage: (this.templateData.siteOptions.backgroundImage.image_src) ? 'url("' + this.templateData.siteOptions.backgroundImage.image_src + '")' : null
			}
		},
        pageMenuBackground() {
			let backgroundColor = 'rgb('
			backgroundColor += (this.templateData.siteOptions.navPage.backgroundColor.value != '' && this.templateData.siteOptions.navPage.backgroundColor.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.navPage.backgroundColor.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.navPage.backgroundColor.defaultColor]
			backgroundColor += ')'
			let color = 'rgb('
			color += (this.templateData.siteOptions.navPage.color.value != '' && this.templateData.siteOptions.navPage.color.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.navPage.color.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.navPage.color.defaultColor]
			color += ')'
			return {
				backgroundColor,
				color
			}
		},
		headerBackground() {
			let backgroundColor = 'rgb('
			backgroundColor += (this.templateData.headerOptions.backgroundColor.value != '' && this.templateData.headerOptions.backgroundColor.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.headerOptions.backgroundColor.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.headerOptions.backgroundColor.defaultColor]
			backgroundColor += ')'
			return {
				backgroundColor,
				backgroundImage: (this.templateData.headerOptions.backgroundImage.image_src) ? 'url("' + this.templateData.headerOptions.backgroundImage.image_src + '")' : null
			}
		},
		headerColor() {
			let color = 'rgb('
			color += (this.templateData.headerOptions.shoppingCart.color.value != '' && this.templateData.headerOptions.shoppingCart.color.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.headerOptions.shoppingCart.color.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.headerOptions.shoppingCart.color.defaultColor]
			color += ')'
			return {
				backgroundColor: color
			}
		},
		productMenuBackground() {
			let backgroundColor = 'rgb('
			backgroundColor += (this.templateData.siteOptions.navMain.backgroundColor.value != '' && this.templateData.siteOptions.navMain.backgroundColor.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.navMain.backgroundColor.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.navMain.backgroundColor.defaultColor]
			backgroundColor += ')'
			return {
				backgroundColor
			}
		},
		buttonColorOne() {
			let backgroundColor = 'rgb('
			backgroundColor += (this.templateData.productSectionsStyles.detailsButton.backgroundColor.value != '' && this.templateData.productSectionsStyles.detailsButton.backgroundColor.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.productSectionsStyles.detailsButton.backgroundColor.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.productSectionsStyles.detailsButton.backgroundColor.defaultColor]
			backgroundColor += ')'
			return {
				backgroundColor
			}
		},
		buttonColorTwo() {
			let backgroundColor = 'rgb('
			backgroundColor += (this.templateData.productSectionsStyles.cartButton.backgroundColor.value != '' && this.templateData.productSectionsStyles.cartButton.backgroundColor.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.productSectionsStyles.cartButton.backgroundColor.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.productSectionsStyles.cartButton.backgroundColor.defaultColor]
			backgroundColor += ')'
			return {
				backgroundColor
			}
		},
		footerBackground() {
			let backgroundColor = 'rgb('
			backgroundColor += (this.templateData.siteOptions.footer.backgroundColor.value != '' && this.templateData.siteOptions.footer.backgroundColor.value != null)
				? this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.footer.backgroundColor.value]
				: this.getStyleOptions.colorSchemes[this.templateData.siteOptions.colorScheme][this.templateData.siteOptions.footer.backgroundColor.defaultColor]
			backgroundColor += ')'
			return {
				backgroundColor
			}
		}
    }
}
</script>

<style lang="scss">
.template-preview-thumbnail {
	height: 198px;
	background-size: cover;
	.thumbnail-page-menu {
		width: 100%;
	    height: 5px;
	    background: #484848;
	}
	.thumbnail-header {
		width: 100%;
	    height: 16px;
		padding: 2px 8px;
		background-size: cover;
		.thumbnail-logo-shape {
			width: 40px;
			height: 11px;
			border-radius: 6px;
			background: #ffffff;
		}
	}
	.thumbnail-product-menu {
		width: 100%;
	    height: 5px;
	    background: #888888;
	}
	.thumbnail-main-body {
		width: auto;
		height: 145px;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-gap: 1px 3px;
		margin: 4px 25px;
		.thumbnail-marquee {
			grid-column: 1 / 4;
			height: 50px;
			background: #4b494a;
		}
		.thumbnail-departments {
			height: 30px;
			background: #616161;
		}
		.thumbnail-section-header {
			grid-column: 1 / 4;
			height: 4px;
			background: #a5a5a5;
		}
		.thumbnail-product-grid {
			background: url("/dashboard/img/thumbproducttile.jpg");
			background-size: contain;
			height: 50px;
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 3px;
			padding: 3px;
			align-items: end;
			.thumbnail-button1 {
				height: 6px;
				background: #6b6b6b;
			}
			.thumbnail-button2 {
				height: 6px;
				background: #000000;
			}
		}
	}
	.thumbnail-footer {
		width: 100%;
		height: 19px;
		background: #5d5d5d;
	}
}
</style>